import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState, } from 'react';
import { useTheme } from '../../theme';
const MediaContext = createContext({
    screenSize: -1,
    breakpoint: -1,
});
export const MediaSizeProvider = ({ useHydrationPatch, ssrBreakpoint: ssrBreakpointParam, children }) => {
    const [renderCount, setRenderCount] = useState(0);
    const ssrBreakpoint = ssrBreakpointParam || -1;
    const theme = useTheme();
    const breakpoints = (theme.breakpoints || ['576px', '768px', '992px', '1200px', '1400px']).map((bp) => parseInt((bp === null || bp === void 0 ? void 0 : bp.slice(0, -2)) || '0'), [theme]);
    const getBreakpoint = (screenSize) => {
        const closestBreakpoint = breakpoints.findIndex((bp) => screenSize < bp);
        return closestBreakpoint === -1 ? breakpoints.length : closestBreakpoint;
    };
    const initialScreenSize = useHydrationPatch || typeof window === 'undefined' ? -1 : window.innerWidth;
    const initialBreakpoint = useHydrationPatch || typeof window === 'undefined'
        ? ssrBreakpoint
        : getBreakpoint(window.innerWidth);
    const [screenSize, setScreenSize] = useState(initialScreenSize);
    const [breakpoint, setBreakpoint] = useState(initialBreakpoint);
    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        const screenSize = window.innerWidth;
        const breakpoint = getBreakpoint(screenSize);
        setScreenSize(screenSize);
        setBreakpoint(breakpoint);
    }, [renderCount, breakpoints]);
    useEffect(() => {
        if (typeof window === 'undefined')
            return;
        const rerenderOnResize = () => {
            setRenderCount((renderCount) => renderCount + 1);
        };
        window.addEventListener('resize', rerenderOnResize);
        return () => {
            window.removeEventListener('resize', rerenderOnResize);
        };
    }, []);
    return (_jsx(MediaContext.Provider, Object.assign({ value: {
            breakpoint,
            screenSize,
        } }, { children: children })));
};
export const useMediaQuery = () => useContext(MediaContext);
